import React from "react";
import PropTypes from "prop-types";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";
import { graphql } from "gatsby";

const Holder = styled.div``;

const SliceImage = ({ slice }) => {
  const image = slice.primary.image.gatsbyImageData;
  const alt = slice.primary.image.alt;
  return (
    <Holder>
        <GatsbyImage alt={alt || ""} image={image} />
    </Holder>
  );
};

SliceImage.propTypes = {
  slice: PropTypes.object.isRequired,
};

export default SliceImage;
